import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
  SuccessIcon,
  FailIcon,
} from '@/components/ui/toast'
import { useToast } from '@/hooks/useToast'

export function Toaster() {
  const { toasts } = useToast()

  // Group toasts by position
  const topRightToasts = toasts.filter(
    t =>
      !t.position || t.position === 'top-right' || t.position === 'bottom-right'
  )
  const topCenterToasts = toasts.filter(t => t.position === 'top-center')

  return (
    <ToastProvider>
      {topRightToasts.map(function ({
        id,
        title,
        description,
        action,
        variant,
        ...props
      }) {
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className='flex items-center gap-3'>
              {variant === 'success' && <SuccessIcon />}
              {variant === 'destructive' && <FailIcon />}
              <div className='grid gap-1'>
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      {topRightToasts.length > 0 && <ToastViewport position='top-right' />}

      {topCenterToasts.map(function ({
        id,
        title,
        description,
        action,
        variant,
        ...props
      }) {
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className='flex items-center gap-3'>
              {variant === 'success' && <SuccessIcon />}
              {variant === 'destructive' && <FailIcon />}
              <div className='grid gap-1'>
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      {topCenterToasts.length > 0 && <ToastViewport position='top-center' />}
    </ToastProvider>
  )
}
